import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';

import * as auth from '../app/modules/Auth/_redux/authRedux';
import { billsSlice } from '../app/modules/ECommerce/_redux/bills/billsSlice';
import { transactionsSlice } from '../app/modules/ECommerce/_redux/transactions/transactionsSlice';
import { guestsSlice } from '../app/modules/ECommerce/_redux/guests/guestsSlice';
import { syncHistoriesSlice } from '../app/modules/ECommerce/_redux/syncHistories/syncHistoriesSlice';

export const rootReducer = combineReducers({
	auth: auth.reducer,
	bills: billsSlice.reducer,
	guests: guestsSlice.reducer,
	transactions: transactionsSlice.reducer,
	syncHistories: syncHistoriesSlice.reducer,
});

export function* rootSaga() {
	yield all([auth.saga()]);
}
